export default tbInterval => {
  tbInterval = parseFloat(tbInterval)

  if (tbInterval === 0.5) {
    return '6 Months'
  } else if (tbInterval === 1) {
    return '1 Year'
  } else if (tbInterval === 4) {
    return '4 Years'
  } else if (tbInterval === 5) {
    return 'No Testing Required'
  } else {
    return 'Undisclosed'
  }
}
